module.exports = {
	"base": {
		"welcome": "Vítá vás Mulligans, uživateli %{name}!",
		"user": "Informace o uživateli",
		"devices": "Zařízení",
		"refunds": "Vrácení peněz",
		"resources": "Zdroje",
		"transactions": "Objednávky a vrácení zboží",
		"email": "E-mail",
		"password": "Heslo",
		"save": "Uložit",
		"sign-out": "Odhlásit se",
		"cancel": "Zrušit",
		"close": "Zavřít",
		"learn-more": "Více informací",
		"required": "Povinné",
		"support": "Podpora",
		"bookshelf": "Bookshelf",
		"launch": "Spustit",
		"download": "Stáhnout",
		"details": "Podrobnosti",
		"cannot-be-blank": "Pole %{field} nemůže být prázdné",
		"saving": "Ukládání…",
		"done": "Hotovo",
		"failed": "Nezdařilo se",
		"copy": "Kopírovat"
	},
	"signin": {
		"login-failure": "E-mail nebo heslo jsou nesprávné",
		"welcome-large": "Vítá vás <span class='inner'>Centrum účtu %{brand}</span>",
		"welcome-small": "<span class='inner'>Centrum účtu</span>",
		"signin-button": "Prihlásit se",
		"forgot-password": "Zapomenuté heslo",
		"new-to-vst": "Jste novým uživatelem služby %{brand}?",
		"create-account": "Vytvořit účet",
		"signing-in": "Přihlašování…",
		"signin-failed": "Přihlášení se nezdařilo"
	},
	"transactions": {
		"price": "Cena",
		"excluded": "(Bez daně)",
		"quantity": "Množství",
		"confirmation#": "Číslo potvrzení",
		"payment": "Platba",
		"purchased": "Zakoupeno",
		"purchase-details": "Podrobnosti o nákupu",
		"subtotal": "Dílčí součet",
		"total": "Celkem",
		"tax": "Daň",
		"loading": "Dobrý den, načítáme vaše transakce…",
		"no-purchases": "Nemáte žádné nákupy.",
		"seller-vat": "DPH prodejce",
		"total-vat": "Celkem zaplaceno na %{vat}",
		"portion": "Daň %{subTax} %{rate} %",
		"vat-disclosure": "Cena zahrnuje %{vat}",
		"purchases": "Nákupy",
		"refunded-items": "Položky, za které byly vráceny peníze",
		"book-title": "Název knihy",
		"refund-details": "Informace o vrácení peněz",
		"print-receipt": "Vytisknout účtenku",
		"request-refund": "Požádat o vrácení peněz",
		"expired": "Vypršelo",
		"expires-in": "Platí do %{date}",
		"details-refund": "Podrobnosti a vrácení peněz",
		"modal": {
			"cant-refund-title": "Vrácení peněz není k dispozici",
			"cant-refund": "Za knihu nelze vrátit peníze z jednoho či více následujících důvodů.",
			"cant-refund-1": "Zobrazili jste si příliš velkou část knihy.",
			"cant-refund-2": "Uplynulo více než 14 dní od data nákupu.",
			"cant-refund-3": "Váš kód zdrojů online byl odhalen.",
			"cant-refund-4": "Za knihu vám už dříve byly vráceny peníze.",
			"cant-refund-5": "Všechny kódy již byly uplatněny nebo za ně byly vráceny peníze.",
			"cant-refund-6": "Uplynulo více než 30 dní od data nákupu.",
			"cant-refund-support": "Pokud si stále nejste jistí, jestli správně chápete zásady vracení peněz ve službě %{brand}, kontaktujte <a href='%{support_url}' target='_blank'>podporu</a>."
		},
		"license": {
			"perpetual": "Přístup online nemá časově omezenou platnost",
			"days": "%{days}denní přístup"
		}
	},
	"devices": {
		"description": "%{brand} umožňuje mít současně aktivováno <span>%{desktop}</span> počítačů a <span>%{mobile}</span> mobilních telefonů / tabletů.",
		"loading": "Dobrý den, získáváme vaše zařízení :)",
		"no-active": "Nemáte žádná aktivní zařízení.",
		"deactivate": "Deaktivovat"
	},
	"user": {
		"personal-information": "Osobní údaje",
		"security-information": "Bezpečnostní informace",
		"notifications": "Oznámení",
		"first-name": "Krestní jméno",
		"last-name": "Príjmení",
		"change-password-title": "Změnit heslo",
		"current-password": "Aktuální heslo",
		"new-password": "Nové heslo",
		"security-password": "Heslo",
		"confirm-new-password": "Potvrzení nového hesla",
		"security-question": "Bezpečnostní otázka",
		"security-info-change": "Změnit",
		"question": "Otázka",
		"answer": "Odpověď",
		"notifications-text": "Posílejte mi čas od času e-maily o změnách mého účtu, změnách v produktech a zvláštních nabídkách.",
		"loading": "Vydržte, Spot zrovna běží pro vaše uživatelské informace 🐶",
		"change-password-text": "Heslo musí obsahovat nejméně 8 znaků, velké písmeno, malé písmeno a zvláštní znak.",
		"email-locked": "E-mail je uzamčen",
		"email-locked-description": "Nemáte oprávnění ke změně e-mailu.",
		"email-locked-more": "Obraťte se na správce.",
		"security-question6": "Jaký je váš oblíbený sport?",
		"security-question7": "Jaká je vaše oblíbená příchuť zmrzliny?",
		"security-question8": "Jak se jmenuje váš domácí mazlíček?",
		"security-question9": "Čím jste se chtěli stát, když jste byli malí?",
		"security-question10": "Jaké bylo příjmení vašeho oblíbeného učitele?",
		"new-password-failure": "Heslo nesplňuje požadavky",
		"confirm-password-failure": "Heslo se musí shodovat",
		"new-password-tooltip": "Musí obsahovat nejméně 8 znaků, velké písmeno, malé písmeno a zvláštní znak.",
		"enter-valid-email": "Zadejte platný e-mail",
		"password-cannot-be-same": "Heslo se nesmí shodovat s předchozím heslem",
		"incorrect-password": "Nesprávné heslo",
		"complete-account": "Vypadá to, že potřebujete <a href='%{href}'>dokončit nastavení svého účtu</a>.",
		"completing-allows": "Až si nastavení účtu dokončíte, budete moci číst knihy offline v našich mobilních aplikacích a sdílet poznámky či zvýraznění s přáteli.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "Dodatky",
		"access-codes": "Přístupové kódy",
		"print-on-demand": "Tisk na vyžádání",
		"check-pod": "Seznamte se s vydavatelskými možnostmi tisku vašich knih.",
		"check-now": "Zkontrolovat",
		"loading": "Vydržte, aktualizujeme vaše zdroje!",
		"in": "v",
		"access-code-intro": "Přístupový kód je heslo sloužící k přístupu k obsahu kurzů online. Jakmile odhalíte kód položky, už ji nebude možné vrátit. Další informace o použití přístupových kódů vám poskytne <a href='%{support_url}' target='_blank'>podpora</a>.",
		"expires": "Platí do",
		"expiration-message": "Obsahuje pokyny k použití přístupového kódu.",
		"copy-fail": "Zkopírování není možné. Vyberte kód a zkopírujte jej ručně.",
		"launch-site": "Spustit stránky",
		"launch-book": "Spustit knihu",
		"reveal-code": "Odhalit kód",
		"no-resources": "Nemáte žádné zdroje.",
		"no-access-codes": "Nemáte žádné přístupové kódy.",
		"no-ancillaries": "Pro tento titul nejsou dostupné žádné dodatky",
		"name": "Jméno",
		"type": "Typ",
		"size": "Velikost",
		"download-all": "Stáhnout vše",
		"back": "Zpět na zdroje"
	},
	"refunds": {
		"states": {
			"refunded": "Vráceny peníze",
			"unavailable": "Vrácení peněz není k dispozici"
		},
		"reasons": {
			"dropped": "Zanechal(a) jsem kurzu",
			"wrong": "Tohle byla nesprávná kniha pro můj kurz",
			"print": "Rozhodl(a) jsem se namísto toho koupit si tištěnou verzi",
			"missing": "Kniha neobsahuje vše, co potřebuji pro svůj kurz (např. disk CD, webový přístup, videa)",
			"other": "Jiné"
		},
		"bulk": {
			"policy": "Kliknutím na níže uvedené tlačítko „Dokončit vrácení peněz“ vyjadřuji souhlas s <a href='%{policy_url}' target='_blank'>pravidly pro vracení peněz</a>společnosti %{brand}.",
			"complete": "Dokončit vrácení peněz",
			"view-details": "Zobrazit podrobnosti o vrácení peněz",
			"success": "Byla podána žádost o vrácení peněz. Vyčkejte prosím 48 hodin na zpracování.",
			"failure": "Jejda, něco se pokazilo. Vrácení peněz bohužel nebylo realizováno.",
			"retry": "Zkuste to znovu",
			"support": "Kontaktovat oddělení podpory",
			"available-codes": "Dostupné kódy",
			"codes-selected": "Vybrané kódy",
			"download": "Stáhnout kódy",
			"partially-refunded": "Částečné vrácení peněz",
			"pick-one": "Chcete-li vrátit peníze, je nutné vybrat alespoň jeden kód"
		},
		"refund": "Vrátit peníze",
		"all": "Vrátit peníze za vše?",
		"missing-reason": "Chcete-li pokračovat, je nutné vybrat důvod",
		"missing-elaboration": "Upřesněte",
		"policy": "Kliknutím na níže uvedené tlačítko „Dokončit žádost o vrácení peněz“ vyjadřuji své pochopení skutečnosti, že v případě opakovaného nákupu této elektronické učebnice ve službě %{brand} přijdu o nárok na vrácení peněz za tuto učebnici. Podívejte se na úplné znění zásad pro vracení.",
		"refunded": "Vráceny peníze",
		"sorry": "Je nám líto, že jste s nákupem nebyli spokojeni.",
		"error": "Došlo k chybě",
		"error-explain": "Vrácení peněz nebylo možné zpracovat. Zkuste to znovu.",
		"why": "Povíte nám důvod?",
		"no-refunds": "Nemáte žádné položky, za které vám byly vráceny peníze.",
		"select-codes": "Vyberte kódy, za které chcete vrátit peníze:",
		"number": "Kolik?",
		"back": "Zpět na vrácení peněz"
	},
	"purchases": {
		"back": "Zpět na nákupy"
	},
	"global-bar": {
		"account": "Nastavení účtu"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/cs.json
 ** module id = 996
 ** module chunks = 0
 **/